import Card from "../../components/card/Card";
import { MdLanguage } from "react-icons/md";
import { useLanguage } from "../../utils/language";
// Styles
import styles from "./language-switch-button.module.css";

function LanguageSwitchButton() {
  const { cycleLanguage, getTranslation } = useLanguage();

  return (
    <div className={styles.langButton}>
      <Card
        backgroundColor="transparent"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItem: "center",
        }}
        onClick={() => cycleLanguage()}
      >
        <MdLanguage style={{ alignSelf: "center", paddingRight: "0.25rem" }} />{" "}
        {getTranslation("btn_lang")}
      </Card>
    </div>
  );
}

export default LanguageSwitchButton;
